import React from 'react';
import { CopyIssue } from '@/types/copyAnalysis';
import { IssueCard } from './IssueCard';

interface IssueListProps {
  issues: CopyIssue[];
  screenshot?: string;
  onImageClick: (image: string) => void;
  onCopy: (text: string, id: number) => void;
  copiedId: number | null;
  isBlurred: boolean;
}

export function IssueList({ 
  issues, 
  screenshot, 
  onImageClick, 
  onCopy, 
  copiedId,
  isBlurred 
}: IssueListProps) {
  return (
    <div className={`space-y-8 transition-all duration-300 ${isBlurred ? 'blur-sm pointer-events-none' : ''}`}>
      <div className="space-y-6">
        {issues.map((issue) => (
          <IssueCard
            key={issue.id}
            issue={issue}
            screenshot={screenshot}
            onImageClick={onImageClick}
            onCopy={onCopy}
            copiedId={copiedId}
          />
        ))}
      </div>
    </div>
  );
}